<section class="ai-card-narration">
  <div class="ai-metric-card" [ngClass]="'tone-' + (block.card.tone || 'neutral')">
    <div>
      <div class="ai-card-label">{{ block.card.label }}</div>
      <div class="ai-card-caption">{{ block.card.caption }}</div>
    </div>
    <strong>{{ block.card.value }}</strong>

    <div class="ai-progress" *ngIf="block.card.progressPercent !== undefined">
      <span>{{ block.card.progressLabel }}:</span>
      <div>
        <i [style.width.%]="block.card.progressPercent"></i>
      </div>
    </div>
  </div>

  <p>{{ block.narration }}</p>
</section>
